import { Skeleton, Stack } from "@mantine/core";
import { FormattedMessage } from "react-intl";

/**
 * Full-page skeleton matching the dashboard layout footprint.
 *
 * Used as TanStack Router `pendingComponent` so route transitions and the
 * initial `/api/me` bootstrap render a steady scaffold instead of a layout
 * shift. Heights are picked to mirror `HeroSummary` (88px) and `LinkTable`
 * rows (56px each) — see DESIGN.md §4 spacing tokens.
 */
export function LoadingShell() {
  return (
    <Stack gap={32} maw={1080} m="0 auto" p={40} role="status" aria-live="polite" aria-busy="true">
      <span style={{ position: "absolute", left: "-9999px" }}>
        <FormattedMessage id="app.boot.loading" defaultMessage="Loading…" />
      </span>
      <Skeleton height={88} radius={2} />
      <Stack gap={16}>
        <Skeleton height={56} radius={2} />
        <Skeleton height={56} radius={2} />
        <Skeleton height={56} radius={2} />
      </Stack>
    </Stack>
  );
}
